import { createContext, useEffect, useState } from "react";
import { toast } from "react-hot-toast";
import clienteAxios from "../config/clienteAxios";

const BusinessContext = createContext();

const BusinessProvider = ({ children }) => {
  const [business, setBusiness] = useState(null);

  const getAllBusiness = async () => {
    try {
      const { data } = await clienteAxios("/business/getall");
      return data.allBusiness?.[0]
    } catch (error) {
      console.log(error);
    }
  };

  useEffect(() => {
    getAllBusiness().then((res) => {
        setBusiness(res)
      });
  }, []);

  const editBusiness = async (businessEdit) => {
    try {
      const { data } = await clienteAxios.put(`business/update`, businessEdit);
      setBusiness(businessEdit)
      toast.success("Se actualizó sección Empresa");
    } catch (error) {
      toast.error("Error al actualizar sección Empresa");
    }
  };

  return (
    <BusinessContext.Provider
      value={{
        editBusiness,
        business,
      }}
    >
      {children}
    </BusinessContext.Provider>
  );
};

export { BusinessProvider };

export default BusinessContext;